import React from "react";

import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import { TYPE_FOLDER } from "util/constants";

import styles from "./DocumentIcon.module.scss";

interface DocumentIconProps {
  fileType: string;
}

export const DocumentIcon: React.FC<DocumentIconProps> = ({ fileType }) => {
  return (
    <Box className={styles.documentIcon}>
      <Icon
        icon={`material-symbols-light:${fileType === TYPE_FOLDER ? "folder-outline-rounded" : "draft-outline-rounded"}`}
        width={20}
        height={20}
        color="#1C1B1F"
      />
    </Box>
  );
};
